import { render } from "./manage-footer-social.vue?vue&type=template&id=5f42ef28"
import script from "./manage-footer-social.vue?vue&type=script&lang=js"
export * from "./manage-footer-social.vue?vue&type=script&lang=js"

import "./manage-footer-social.vue?vue&type=style&index=0&id=5f42ef28&lang=scss"

import exportComponent from "C:\\Users\\yrabie\\Documents\\Projects\\Awsat Admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__